









import { defineComponent } from '@vue/composition-api';

const SmallChartPanel = defineComponent({
  props: {
    title: {},
  },
  // setup() {},
});

export default SmallChartPanel;
